/* Amalia J & Boutique – Jewish holiday page: upcoming dates (uses @hebcal/core, GPLv2). */
(function () {
  var el = document.getElementById('amj-jw-hconfig');
  if (!el) return;
  var C = JSON.parse(el.textContent), ES = C.lang === 'es';
  var MONTHS_EN = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
  var MES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  var MEN = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var DES = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  var DEN = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  function lbl(d) { return ES ? DES[d.getDay()] + ' ' + d.getDate() + ' de ' + MES[d.getMonth()] + ' de ' + d.getFullYear() : DEN[d.getDay()] + ', ' + MEN[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear(); }
  var today = new Date(); today.setHours(0, 0, 0, 0);
  var link = C.calBase + MONTHS_EN[today.getMonth()] + '-' + today.getFullYear();
  function setLinks(url) { document.querySelectorAll('[data-amj-jw-callink]').forEach(function (a) { a.href = url; }); }
  setLinks(link);
  var pb = document.querySelector('[data-amj-jw-printbless]'); if (pb) pb.addEventListener('click', function () { window.print(); });
  if (!window.hebcal) return;
  var H = window.hebcal, F = H.flags;
  var evs = H.HebrewCalendar.calendar({ start: today, end: new Date(today.getTime() + 3 * 366 * 86400000), il: false, sedrot: true });
  function match(desc) { if (/Katan|LaBehemot/.test(desc)) return false; for (var i = 0; i < C.keys.length; i++) { var k = C.keys[i]; if (desc === k || desc.indexOf(k) === 0) return true; } return false; }
  var runs = [], cur = null;
  evs.forEach(function (e) {
    var desc = e.getDesc(); if (!match(desc) || (e.getFlags() & F.EREV)) return;
    var d = e.getDate().greg();
    if (cur && (d - cur.end) <= 86400000 * 1.5) { cur.end = d; return; }
    cur = { start: d, end: d, hd: e.getDate(), fast: !!(e.getFlags() & F.MINOR_FAST), wk: desc.indexOf('Parashat') === 0 ? desc : '' }; runs.push(cur);
  });
  var out = document.getElementById('amj-jw-dates'); if (!out) return;
  if (!runs.length) { out.innerHTML = ''; return; }
  var html = '';
  runs.slice(0, 3).forEach(function (r, i) {
    var eve = new Date(r.start.getTime() - 86400000);
    var dd = r.fast ? lbl(r.start) + (ES ? ', desde el amanecer hasta el anochecer' : ', from dawn to nightfall') :
      (ES ? 'Desde la noche del ' : 'From the evening of ') + lbl(eve) + (r.end > r.start ? (ES ? ' hasta el ' : ' to ') + lbl(r.end) : '');
    if (r.wk) dd += ' · ' + (ES ? r.wk.replace('Parashat', 'Parashá') : r.wk);
    html += '<div><dt>' + (r.wk ? (ES ? 'Shabat' : 'Shabbat') : r.hd.getFullYear()) + '</dt><dd>' + dd + '</dd></div>';
  });
  out.innerHTML = html;
  var hd = document.getElementById('amj-jw-hdate');
  var first = runs[0], n = Math.round((first.start - (first.fast ? 0 : 86400000) - today) / 86400000);
  if (hd) hd.textContent = (ES ? 'Próxima vez: ' : 'Next: ') + lbl(first.start) + (n >= 0 ? (ES ? ' · en ' + n + ' días' : ' · in ' + n + ' days') : '');
  setLinks(C.calBase + MONTHS_EN[first.start.getMonth()] + '-' + first.start.getFullYear() + '?d=' + first.start.getFullYear() + '-' + ('0' + (first.start.getMonth() + 1)).slice(-2) + '-' + ('0' + first.start.getDate()).slice(-2));
})();
